import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Navbar from '../components/Navbar'
import HeroSection from '../components/HeroSection'
import StoryFeed from '../components/StoryFeed'
import SEO from '../components/SEO'

export default function Home() {
  return (
    <div>
      <SEO
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Verse',
          url: 'https://versesite.net',
          description: 'Verse is a social writing platform where you can publish stories, fanfiction, quizzes, and connect with a community of readers and writers.',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://versesite.net/browse?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <Navbar />
      <HeroSection />
      <StoryFeed />
      <WritersSection />
      <Footer />
    </div>
  )
}

function WritersSection() {
  return (
    <div style={{ padding: '0 24px 72px', maxWidth: '1248px', margin: '0 auto' }}>
      <div className="writers-section">
        <div className="writers-section__header">
          <h2 className="writers-section__title">Get started</h2>
          <p className="writers-section__sub">
            Everything you need to start writing, stay in good standing, and grow your audience.
          </p>
        </div>
        <div className="writers-section__grid">
          <Link to="/write" className="writers-card writers-card--write">
            <div className="writers-card__icon-wrap">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z" />
              </svg>
            </div>
            <div className="writers-card__label">Start writing</div>
            <div className="writers-card__desc">Publish your first story — it takes less than a minute to get started.</div>
          </Link>
          <Link to="/guidelines" className="writers-card writers-card--guidelines">
            <div className="writers-card__icon-wrap">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
            </div>
            <div className="writers-card__label">Content guidelines</div>
            <div className="writers-card__desc">Ratings, what's allowed, fan fiction rules, and how enforcement works.</div>
          </Link>
          <Link to="/tips" className="writers-card writers-card--tips">
            <div className="writers-card__icon-wrap">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="9" y1="18" x2="15" y2="18" />
                <line x1="10" y1="22" x2="14" y2="22" />
                <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" />
              </svg>
            </div>
            <div className="writers-card__label">Writing tips</div>
            <div className="writers-card__desc">Craft advice, story structure, and how to build an audience on Verse.</div>
          </Link>
        </div>
      </div>
    </div>
  )
}

function RedditIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z"/>
    </svg>
  )
}

function DiscordIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057c.002.022.015.043.032.054a19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
    </svg>
  )
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src="/verse-icon.png" alt="Verse" className="footer__logo-icon" />
              Verse
            </div>
            <p className="footer__tagline">
              A creative writing community where every story finds its home.
              Write fanfiction, original fiction, and more.
            </p>
          </div>

          <div className="footer__links">
            <div className="footer__col">
              <div className="footer__col-title">Platform</div>
              <ul>
                <li><Link to="/browse">Browse Stories</Link></li>
                <li><Link to="/quizzes">Quizzes</Link></li>
                <li><Link to="/community">Community</Link></li>
                <li><a href="https://discord.gg/gu7fFhgTJW" target="_blank" rel="noopener noreferrer">Discord</a></li>
                <li><a href="https://www.reddit.com/r/Versefandomplatform/" target="_blank" rel="noopener noreferrer">Reddit</a></li>
              </ul>
            </div>
            <div className="footer__col">
              <div className="footer__col-title">Writers</div>
              <ul>
                <li><Link to="/write">Start Writing</Link></li>
                <li><Link to="/guidelines">Guidelines</Link></li>
                <li><Link to="/tips">Writing Tips</Link></li>
              </ul>
            </div>
            <div className="footer__col">
              <div className="footer__col-title">Company</div>
              <ul>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/privacy">Privacy</Link></li>
                <li><Link to="/terms">Terms</Link></li>
                <li><Link to="/dmca">DMCA</Link></li>
                <li><a href="mailto:support@versesite.com">Support</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <span className="footer__copy">© 2026 Verse Interactive Platforms LLC. All rights reserved.</span>
          <span className="footer__copy" style={{ marginLeft: 12 }}>Icon by <a href="https://misakisocial.carrd.co/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>Misaki</a></span>
          <div className="footer__socials">
            <a
              href="https://discord.gg/gu7fFhgTJW"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-btn footer__social-btn--discord"
              title="Join our Discord"
            >
              <DiscordIcon />
            </a>
            <a
              href="https://www.reddit.com/r/Versefandomplatform/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-btn footer__social-btn--reddit"
              title="Join our Reddit"
            >
              <RedditIcon />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
